module.exports = __webpack_public_path__ + "copir.svg?4f3a0783a74693abcf8f66291ac5aba4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/copir.svg
// module id = 78
// module chunks = 0